import { render } from "./ModalConfirmSms.vue?vue&type=template&id=39c00bb4&scoped=true&ts=true"
import script from "./ModalConfirmSms.vue?vue&type=script&lang=ts"
export * from "./ModalConfirmSms.vue?vue&type=script&lang=ts"

import "./ModalConfirmSms.vue?vue&type=style&index=0&id=39c00bb4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c00bb4"]])

export default __exports__